<template>
    <transition name="bounce" mode="out-in">
        <div v-if="show" class="modal-backdrop">
            <div class="modal-container" :class="{ center: center === true }">
                <slot />
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        center: {
            // Should content be centered
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    z-index: 2;

    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    overflow-y: auto;

    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
}
.modal-container {
    width: 100%;
    min-height: 100%;
    z-index: 3;
}
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Animations */
</style>
